<template>
  <data-list
    ref="dataList"
    class="content md"
    :url="url"
    entity-name="报警统计"
    hide-edit
    hide-delete
    :action="action"
    :columns="columns"
    :modal-width="640"
    :modal-form="{
      layout: 'horizontal',
      labelAlign: 'left',
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    }"
    :search-key-type="searchKeyType"
    @detail="showDetail"
  >
    <template v-slot:query="{ form }">
      <a-form-model-item label="预警类型">
        <a-select
          v-model="form.type"
          :options="warningOptions"
          placeholder="选择预警类型"
          allow-clear
          style="width: 200px"
          @change="updateList"
        ></a-select>
      </a-form-model-item>
      <a-form-model-item label="预警级别">
        <a-select
          v-model="form.alarm_level"
          :options="levelOptions"
          placeholder="选择预警级别"
          allow-clear
          style="width: 200px"
          @change="updateList"
        ></a-select>
      </a-form-model-item>
      <a-form-model-item label="处理状态">
        <a-select
          v-model="form.status"
          :options="statusOptions"
          placeholder="选择处理状态"
          allow-clear
          style="width: 200px"
          @change="updateList"
        ></a-select>
      </a-form-model-item>
      <a-form-model-item label="预警时间">
        <a-range-picker
          v-model="form.alarm_time"
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          allow-clear
          @change="updateList"
          class="range-picker"
        />
      </a-form-model-item>
    </template>
    <template v-slot:button="{ form }">
      <a-button type="primary" @click="exportData(form)" :loading="exporting">
        {{ exporting ? "正在导出" : "数据导出" }}
      </a-button>
    </template>
  </data-list>
</template>

<script>
import { getTemple } from "@/common/js/storage";
import { downLoadBlobFile, getKeyTitle } from "@/common/js/tool";
import { statusOptions, levelOptions, warningOptions } from "@/common/constant/safe";

export default {
  name: "Alarms",
  data() {
    return {
      url: "/admin/security-work-order",
      columns: [
        { title: "预警时间", dataIndex: "alarm_time" },
        {
          title: "预警类型",
          dataIndex: "type",
          customRender: (text) => <span>{getKeyTitle(warningOptions, text, "value", "label")}</span>,
        },
        {
          title: "预警级别",
          dataIndex: "alarm_level",
          customRender: (text) => <span>{getKeyTitle(levelOptions, text, "value", "label")}</span>,
        },
        {
          title: "处理状态",
          dataIndex: "status",
          customRender: (text) => <span>{getKeyTitle(statusOptions, text, "value", "label")}</span>,
        },
      ],
      searchKeyType: {
        alarm_time: function (form, key) {
          let res = "";
          const value = form[key];
          if (value?.length === 2) {
            res = `&filter[${key}][gte]=${value[0]} 00:00:00&filter[${key}][lte]=${value[1]} 23:59:59`;
          }
          return res;
        },
      },
      statusOptions,
      warningOptions,
      levelOptions,
      exporting: false,
    };
  },
  computed: {
    action() {
      return this.$route.meta.action;
    },
  },
  methods: {
    updateList() {
      this.$refs.dataList.updateList();
    },
    exportData(form) {
      if (this.exporting) return;
      this.exporting = true;
      const temple = getTemple();
      let url = `${this.url}/export?temple_id=${temple}`;
      if (form.type) {
        url += `&type=${form.type}`;
      }
      if (form.alarm_level) {
        url += `&alarm_level=${form.alarm_level}`;
      }
      if (form.status) {
        url += `&status=${form.status}`;
      }
      if (form.create_time?.length === 2) {
        url += `&start_time=${form.create_time[0]}&end_time=${form.create_time[1]}`;
      }
      this.$axios(url, { noTempleFilter: true, responseType: "blob" })
        .then((res) => {
          downLoadBlobFile(res, "报警统计记录");
        })
        .finally(() => {
          this.exporting = false;
        });
    },
    showDetail({ item }) {
      this.$router.push({ name: "AlarmsDetail", params: { id: item.id } });
    },
  },
};
</script>

<style lang="less" scoped></style>
